import type { ReviewServicePorts } from "../../model";

import type { Common } from "./ios";

import { EMPTY } from "~/shared/str";

function mapDtoToEntity({
  pros,
  cons,
  firstName,
  lastName,
  createdAt,
  reviewContent,
  ...rest
}: Common.OutSchema): ReviewServicePorts.ProviderIos.Common.OutSchema {
  return {
    ...rest,
    pros: pros ?? EMPTY,
    cons: cons ?? EMPTY,
    text: reviewContent ?? EMPTY,
    customer: {
      firstName: firstName ?? EMPTY,
      lastName: lastName ?? EMPTY,
    },
    createdAt: new Date(createdAt),
  };
}

function mapDtoToEntity2(
  value: Common.OutSchema2,
): ReviewServicePorts.ProviderIos.Common.OutSchema2 {
  const { contactEmail, contactPhone, isApproved, orderNumber } = value;
  const { customer, ...entity } = mapDtoToEntity(value);
  return {
    ...entity,
    customer: {
      ...customer,
      email: contactEmail ?? EMPTY,
      phone: contactPhone ?? EMPTY,
    },
    isApproved,
    orderNumber,
  };
}

export { mapDtoToEntity, mapDtoToEntity2 };
